<template>
    <div class="Row">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'Row',
}
</script>

<style lang="scss" scoped>
@use 'sass:math';
@import 'globals.scss';

.Row {
    @extend %clear;
    margin-left: -$grid-gutter-width;
    margin-right: -$grid-gutter-width;

    &.normalize > [class^='Col'] {
        padding-left: math.div($grid-gutter-width, 2);
        padding-right: math.div($grid-gutter-width, 2);

        @include breakpoint(xs) {
            padding-left: $grid-gutter-width;
            padding-right: $grid-gutter-width;
        }

        &:first-child {
            padding-left: $grid-gutter-width;
        }
        &:last-child {
            padding-right: $grid-gutter-width;
        }
    }
}
</style>
